import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { TeamsTableDefinitionZod } from '../tables';

type Arguments = {
    userId: string;
};

export const schemaTeamResolver_GetByLeaderId = TeamsTableDefinitionZod.nullable();

export type SchemaTeamResolver_GetByLeaderId = z.infer<typeof schemaTeamResolver_GetByLeaderId>;

export type TeamResolver_GetByLeaderId = Resolver<Arguments, SchemaTeamResolver_GetByLeaderId>;
